import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { TabularQuestion } from 'src/app/models/TabularQuestion.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';

@Component({
    selector: 'que-table-question-display',
    imports: [CommonModule],
    templateUrl: './table-question-display.component.html',
    styleUrls: ['./table-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableQuestionDisplayComponent {
  @Input()
  question?:Question;
  @Input() viewAnswer = false;
  arr: boolean[][] = []; 
  arr2=Array.from(Array(4).keys());
  arr3=Array.from(Array(5).keys());
  secondaryColor$=inject(QuestionnaireStore).secondaryColor$
  changed(column:number){

  }
  choose(i: number, j: number): void {
    // Assuming arr is initialized somewhere in your component
    if (!this.arr) {
      this.arr = [];
    }
  
    // Assuming arr[i] is initialized as an array
    if (!this.arr[i]) {
      this.arr[i] = [];
    }
  
    // Toggle the value in the array at position (i, j)
    this.arr[i][j] = !this.arr[i][j];
  
    // Add any additional logic you need here

    // For example, you can log the current state of arr
  }
}
